import { Toast } from '@base-ui-components/react/toast'
import { ToastList } from './toast-list'
import { ToastViewport } from './toast-viewport'

export const createToastManager = Toast.createToastManager

export function ToastManager({ manager, ...props }: ToastManager.Props) {
  return (
    <Toast.Provider toastManager={manager} {...props}>
      <ToastViewport>
        <ToastList />
      </ToastViewport>
    </Toast.Provider>
  )
}

export namespace ToastManager {
  export interface Props extends Omit<Toast.Provider.Props, 'children' | 'toastManager'> {
    manager: Toast.Provider.Props['toastManager']
  }
}
